(function () {
    'use strict';

    /**
    * @memberof app
    * @ngdoc controller
    * @name UserController
    * @description
    * This is main controller
    **/

    angular
        .module('app')
        .controller('UserController', UserController);

    UserController.$inject = ['$scope', 'UserService', '$window','$timeout'];


    function UserController($scope, UserService, $window,$timeout) {

        var vm = this;
        vm.ProfileForm = {};
        vm.username = "";
        vm.recuperarclave = false;
        vm.msgerror = false;
        vm.msgerrorlogin = false;
        vm.msgemail = false;
        vm.errors = false;
        vm.reseteado = false;
        vm.loading = false;
        vm.updatedProfile = false;
        vm.step = 1;
        vm.persona = false;
        vm.errorStep2 = false;
        vm.errorStep3 = false;
        vm.errorStep4 = false;
        vm.clickednextbutton = false;


        /**
         * Updates the user's profile information.
         *
         * @function updateProfile
         * @memberof UserController
         * @instance
         * @param {Object} vm - The view model of the UserController.
         * @param {Object} vm.ProfileForm - The user's profile form data.
         * @param {UserService} UserService - The service for user-related operations.
         * @param {Object} $timeout - AngularJS $timeout service for running functions after a delay.
         * @returns {Promise} A promise that resolves when the profile update is successful.
         */
        vm.updateProfile = () => {
            
            return UserService.UpdateProfile(vm.ProfileForm).then((data) => {
                vm.getProfile();
                vm.updatedProfile = true;
                $timeout(() => {vm.updatedProfile = false;}, 3000);                
            })
        };

        /**
         * Retrieves the user's profile information.
         *
         * @function getProfile
         * @memberof UserController
         * @instance
         * @param {Object} vm - The view model of the UserController.
         * @returns {Promise} A promise that resolves with the user's profile data.
         * The promise resolves with an object containing the user's profile information in the 'profile' property.
         */
        vm.getProfile = () => {

            return UserService.GetProfile(vm).then((data) => {

                vm.ProfileForm = data.profile;

            });

        };

        /**
         * Handles the change password functionality.
         *
         * @function changepassword
         * @memberof UserController
         * @instance
         * @param {Object} form - The form object containing the user's current and new password.
         * @returns {void}
         *
         * @fires UserService#Changepassword - Calls the Changepassword method of the UserService.
         * @listens UserService#Changepassword - Listens for the response from the Changepassword method.
         * @modifies {Object} vm.msgerror - Sets to false to clear any previous error messages.
         * @modifies {Object} vm.finalpass - Stores the new password if the change is successful.
         * @modifies {Object} vm.msgerrorcontra - Stores any error message related to the new password.
         * @modifies {Object} vm.msgerror - Stores any general error message.
         * @modifies {Object} vm.msgerrorlogin - Sets to true if there are any login errors.
         */
        vm.changepassword = function (form) {
            vm.msgerror = false;
            UserService.Changepassword(vm).then(function (data) {
                vm.finalpass = data.finalpass;
                vm.msgerrorcontra = data.msgerrorcontra;
                vm.msgerror = data.msgerror;
                vm.msgerrorlogin = data.msgerrorlogin;
            });
        };

        vm.recovery = function (form) {
            vm.msgerror = false;
            vm.msgemail = false;
            vm.loading = true;
            UserService.Recuperarpassword(vm).then(function (data) {
                vm.msgerror = data.msgerror;
                vm.msgemail = data.msgemail;
                vm.username = data.username;
                vm.msgcorrecto = data.msgcorrecto;
                if (vm.msgemail == undefined && vm.msgcorrecto == undefined && vm.msgerror == undefined) {
                    vm.msgerrorlogin = true;
                }
                vm.loading = false;
            });
        };

        vm.login = function () {

            vm.errors = false;
            UserService.Login(vm).then(function (data) {
                vm.errors = data.errors;
                vm.msgcorrecto = data.msgcorrecto;
                vm.msgemail = data.msgemail;

                if (vm.msgemail == undefined && vm.msgcorrecto == undefined && vm.errors == undefined) {
                    vm.msgerrorlogin = true;
                }

                if (data.slugRegistro) {
                  
                    window.location = data.slugRegistro;
                    window.open(data.slugRegistro, '_system');
                }

            });
        };

        vm.reset = function (form) {
            vm.username = "";
            vm.password = "";
            vm.reseteado = true;
            form.$setPristine();
        }

        vm.registroUsuario = function(form){
            if (vm.loading) {
               return;
            }
            if(form.$valid){
                vm.loading = true;
            }
            UserService.Registroform(vm).then(function(data){
                  vm.loading = false;
                  vm.errorregistro = data.error;
                  vm.nuevoregistro = data.nuevoregistro;
                  vm.guardado = data.guardado;
                  if ( vm.guardado) {
                    vm.step++;
                  }
               })
        }

        vm.nextStepRegistro = function(step){
      
            if (vm.step == 1 && step == 1 && vm.persona ) {
                vm.step++;
                return;
            }

            if (vm.step == 2 && step == 2 && vm.persona == 'fisica') {
                if (vm.nombre && vm.apellidos && vm.dni ) {
                    vm.errorStep2 = false;
                    vm.step++;
                } else {
                    vm.errorStep2 = true;
                }
                return;
            }

            if (vm.step == 2 && step == 2 && vm.persona == 'juridica') {
                if (vm.nombre && vm.apellidos && vm.dni && vm.nifEmpresa && vm.nombreEmpresa ) {
                    vm.errorStep2 = false;
                    vm.step++;
                } else {
                    vm.errorStep2 = true;
                }
                return;
            }


            if (vm.step == 3 && step == 3) {
                if (vm.direccion && vm.localidad && vm.pais != 0 && vm.cp && vm.pais) {
                    vm.errorStep3 = false;
                    vm.step++;
                } else {
                    vm.errorStep3 = true;
                }
                return;
            }

            // if (vm.step == 4 && step == 4) {
            //     if (vm.email && vm.telefono && vm.politica && 
            //         vm.password && vm.rep_password && vm.password == vm.rep_password) {
            //         vm.errorStep4 = false;
            //         vm.step++;
            //     } else {
            //         vm.errorStep4 = true;
            //     }
            //     return;
            // }


        }

        vm.prevStep = function(){
            vm.step = vm.step -1;
        }


    }
})();